"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const colors_1 = require("../colors");
const custom_1 = require("./custom");
exports.theme = custom_1.createThemeFromColor('#242B38', 'dark-blue', 'Xanh đậm', {
    override: {
        primaryBackgroundColor: colors_1.getStaticColors({ isDark: true }).blue,
    },
});
//# sourceMappingURL=dark-blue.js.map